import { SettingsComponent } from './../components/settings/settings.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { SocialDetailComponent } from './../components/settings/social-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';

export const settingsRoutes = {
    path: 'settings',
    data: {
        breadcrumbs: {
            label: 'Nastavení',
            icon: 'settings'
        },
        state: 'settings'
    },
    children: [
        {
            path: '',
            component: SettingsComponent,
            canActivate: [AuthGuard]
        },
        {
            path: 'file/:id',
            component: FileDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Upravit soubor'
                },
                state: 'pages-media-edit'
            },
            outlet: 'modal'
        },
        {
            path: 'files',
            component: FileBrowseComponent,
            data: {
                breadcrumbs: {
                    label: 'Vybrat soubor'
                },
                state: 'settings-media-browse',
                isSingle: true,
                imgOnly: true
            },
            outlet: 'browse'
        },
        {
            path: 'social/add',
            component: SocialDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Přidat sociální síť',
                    icon: 'settings',
                    state: 'social-add'
                }
            }
        },
        {
            path: 'social/edit/:id',
            component: SocialDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Upravit sociální síť',
                    icon: 'settings',
                    state: 'social-edit'
                }
            }
        },

        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat sociální síť'
                },
                state: 'social-delete',
                apiUri: 'socials'
            },
            outlet: 'modal'
        }
    ]
};
